import { render } from "./QuestaoOpcaoEdicao.vue?vue&type=template&id=a344b938&scoped=true&ts=true"
import script from "./QuestaoOpcaoEdicao.vue?vue&type=script&lang=ts"
export * from "./QuestaoOpcaoEdicao.vue?vue&type=script&lang=ts"

import "./QuestaoOpcaoEdicao.vue?vue&type=style&index=0&id=a344b938&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a344b938"]])

export default __exports__